import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center px-4 py-24 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-secondary-500">
        <i className="ri-compass-3-line text-3xl"></i>
      </span>
      <h1 className="mt-6 font-heading text-5xl font-bold text-primary-700">404</h1>
      <h2 className="mt-3 font-heading text-xl font-semibold text-foreground-950">
        页面走丢了
      </h2>
      <p className="mt-3 max-w-md text-sm text-foreground-600">
        抱歉，你访问的页面不存在或已被移除。不妨返回首页，继续浏览伦理影视作品。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/all"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-apps-2-line"></i>
          浏览全部作品
        </Link>
      </div>
    </div>
  );
}